/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Explorer_Kanban_Update_Record_Failed_ToastInputs */

const en_explorer_kanban_update_record_failed_toast = /** @type {(inputs: Explorer_Kanban_Update_Record_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to update record: ${i?.error}`)
};

const fr_explorer_kanban_update_record_failed_toast = /** @type {(inputs: Explorer_Kanban_Update_Record_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de la mise a jour de l'enregistrement : ${i?.error}`)
};

const de_explorer_kanban_update_record_failed_toast = /** @type {(inputs: Explorer_Kanban_Update_Record_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktualisierung des Datensatzes fehlgeschlagen: ${i?.error}`)
};

const it_explorer_kanban_update_record_failed_toast = /** @type {(inputs: Explorer_Kanban_Update_Record_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile aggiornare il record: ${i?.error}`)
};

const ru_explorer_kanban_update_record_failed_toast = /** @type {(inputs: Explorer_Kanban_Update_Record_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось обновить запись: ${i?.error}`)
};

const es_explorer_kanban_update_record_failed_toast = /** @type {(inputs: Explorer_Kanban_Update_Record_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo actualizar el registro: ${i?.error}`)
};

const zh_cn2_explorer_kanban_update_record_failed_toast = /** @type {(inputs: Explorer_Kanban_Update_Record_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`更新记录失败：${i?.error}`)
};

const ja_explorer_kanban_update_record_failed_toast = /** @type {(inputs: Explorer_Kanban_Update_Record_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`レコードの更新に失敗しました: ${i?.error}`)
};

const hi_explorer_kanban_update_record_failed_toast = /** @type {(inputs: Explorer_Kanban_Update_Record_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`रिकॉर्ड अपडेट करने में विफल: ${i?.error}`)
};

const pt_pt2_explorer_kanban_update_record_failed_toast = /** @type {(inputs: Explorer_Kanban_Update_Record_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao atualizar o registro: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to update record: {error}" |
*
* @param {Explorer_Kanban_Update_Record_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_kanban_update_record_failed_toast = /** @type {((inputs: Explorer_Kanban_Update_Record_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Kanban_Update_Record_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_kanban_update_record_failed_toast(inputs)
	if (locale === "de") return de_explorer_kanban_update_record_failed_toast(inputs)
	if (locale === "it") return it_explorer_kanban_update_record_failed_toast(inputs)
	if (locale === "ru") return ru_explorer_kanban_update_record_failed_toast(inputs)
	if (locale === "es") return es_explorer_kanban_update_record_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_kanban_update_record_failed_toast(inputs)
	if (locale === "ja") return ja_explorer_kanban_update_record_failed_toast(inputs)
	if (locale === "hi") return hi_explorer_kanban_update_record_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_kanban_update_record_failed_toast(inputs)
	return en_explorer_kanban_update_record_failed_toast(inputs)
});